export const logError = (
  eventName: string,
  eventType: 'error' | 'warning' | 'info',
  payload?: object | unknown,
): void => {
  switch (eventType) {
    case 'info':
      console.log(eventName, eventType, payload);
      return;
    case 'warning':
      console.warn(eventName, eventType, payload);
      return;
    case 'error':
    default:
      console.error(eventName, eventType, payload);
      return;
  }
};
